import React from 'react'
import { withRouter } from 'react-router-dom'
import { AuthContext } from '../../main/authProvider'
import HandleErrorService from '../../app/service/handleErrorService'
import GeneralServices from '../../app/service/generalServices'
import DateIntervalCalendar from '../../components/calendar/dateIntervalCalendar'
import Card from '../../components/card'
import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog'
import SelectMenu from '../../components/selectMenu'
import DDABoletoPagamentoService from '../../app/service/relatorios/ddaBoletoPagamentoService'
import DDABoletoPagamentoTable from '../../components/relatorios/ddaBoletoPagamentoTable'
import * as popUp from '../../components/toastr'
import AuthService from '../../app/service/authService'

const tipoDataList = [
    {label: 'Selecione...', value: ''},
    {label: 'Data de Disponibilizacao', value: 'DATA_DISPONIBILIZACAO'},
    {label: 'Data de Vencimento', value: 'DATA_VENCIMETNO'},
]

class DDABoletoPagamento extends React.Component {

    constructor(){
        super()
        this.ddaBoletoPagamentoService = new DDABoletoPagamentoService()
    }

    state = {

        selectedTipoData: '',
        missingTipoData: false,

        selectedDateFilterType: '',
        missingFilterType: false,
        missingAnyDate: false,

        initialDate: '',
        initialDateView: '',
        finalDate: '',
        finalDateView: '',

        list: [],
        loading: false,
        isSearching: false,
        isFinishedSearch: false,

        habilitaBusca: true,

        displayImportDialog: false,
        isImporting: false,

        importSelectedDateFilterType: '',
        importMissingFilterType: false,
        importMissingAnyDate: false,

        importInitialDate: '',
        importInitialDateView: '',
        importFinalDate: '',
        importFinalDateView: '',

    }

    handleTipoDataChange = async (event) => {
        const value = event.target.value
        await this.setState({selectedTipoData: value})
    }

    handleDateFilterChange = (selectedDateFilterType) => {
        this.setState({selectedDateFilterType})
    }

    handleDateChange = async (initialDate, finalDate) => {
        await this.setState({initialDate})
        await this.setState({initialDateView: GeneralServices.convertBrStringToJsDate(initialDate)})

        await this.setState({finalDate})
        await this.setState({finalDateView: GeneralServices.convertBrStringToJsDate(finalDate)})
    }

    resetView = () => {
        this.setState({missingTipoData: false})
        this.setState({missingFilterType: false})
        this.setState({missingAnyDate: false})
        this.setState({list: []})
    }

    checkData = () => {
        var check = true

        if(!this.state.selectedTipoData){
            this.setState({missingTipoData: true})
            check = false
        }

        if(!this.state.selectedDateFilterType){
            this.setState({missingFilterType: true})
            check = false
        }

        if(!this.state.initialDate || !this.state.finalDate){
            this.setState({missingAnyDate: true})
            check = false
        }

        return check
    }

    toggleButton = () => {
        this.setState({habilitaBusca: !this.state.habilitaBusca})
    }

    callSearch = () => {
        this.resetView()

        if(this.checkData()){
            this.search()
        }
    }

    search = () => {
        this.setState({loading: true})
        this.toggleButton()
        this.setState({isSearching: true})
        this.setState({isFinishedSearch: false})

        const obj = {
            tipoFiltroData: this.state.selectedTipoData,
            dataInicial: this.state.initialDate,
            dataFinal: this.state.finalDate,
        }

        this.ddaBoletoPagamentoService.getByDateInterval(obj)
        .then(response => {
            const listaComDatasDeOrdenacao = response.data.ddaBoletoPagamentoList.map(boleto => ({
                ...boleto,
                dataDisponibilizacaoDDAOrdenacao: GeneralServices.convertBrStringToJsDate(boleto.dataDisponibilizacaoDDA),
                dataVencimentoOrdenacao: GeneralServices.convertBrStringToJsDate(boleto.dataVencimento),
                dataHoraImportacaoOrdenacao: GeneralServices.convertCompleteBrStringToJsDate(boleto.dataHoraImportacao),
            }))
            this.setState({list: listaComDatasDeOrdenacao})
            this.setState({isSearching: false})
            this.setState({isFinishedSearch: true})
        })
        .catch(error => {
            HandleErrorService.handleError(error)
            this.setState({isSearching: false})
            this.setState({isFinishedSearch: true})
        })
        .finally(() => {
            this.setState({loading: false})
        })
    }

    inputSelectTipoDataErrorClass = () => {
        if(this.state.missingTipoData)
            return "is-invalid"
    }

    openImportDialog = () => {
        this.setState({displayImportDialog: true})
    }

    closeImportDialog = () => {
        this.setState({displayImportDialog: false})
        this.setState({importSelectedDateFilterType: ''})
        this.setState({importMissingFilterType: false})
        this.setState({importMissingAnyDate: false})
        this.setState({importInitialDate: ''})
        this.setState({importInitialDateView: ''})
        this.setState({importFinalDate: ''})
        this.setState({importFinalDateView: ''})
    }

    handleImportDateFilterChange = (importSelectedDateFilterType) => {
        this.setState({importSelectedDateFilterType})
    }

    handleImportDateChange = async (importInitialDate, importFinalDate) => {
        await this.setState({importInitialDate})
        await this.setState({importInitialDateView: GeneralServices.convertBrStringToJsDate(importInitialDate)})

        await this.setState({importFinalDate})
        await this.setState({importFinalDateView: GeneralServices.convertBrStringToJsDate(importFinalDate)})
    }

    checkImportData = () => {
        var check = true

        if(!this.state.importSelectedDateFilterType){
            this.setState({importMissingFilterType: true})
            check = false
        }

        if(!this.state.importInitialDate || !this.state.importFinalDate){
            this.setState({importMissingAnyDate: true})
            check = false
        }

        return check
    }

    callImportar = () => {
        this.setState({importMissingFilterType: false})
        this.setState({importMissingAnyDate: false})

        if(this.checkImportData()){
            this.importarBoletos()
        }
    }

    importarBoletos = () => {
        this.setState({isImporting: true})

        const obj = {
            dataInicial: this.state.importInitialDate,
            dataFinal: this.state.importFinalDate,
        }

        this.ddaBoletoPagamentoService.importar(obj)
        .then(response => {
            popUp.successPopUp("Importação de boletos realizada com sucesso!")
            this.closeImportDialog()

            if(this.state.isFinishedSearch){
                this.search()
            }
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
        .finally(() => {
            this.setState({isImporting: false})
        })
    }

    render() {

        const renderForm = () => {
            return (
                <div>
                <div className="row">

                    <div className="col-md-3">
                        <label htmlFor="selectedTipoData">Filtrar por</label>
                        <SelectMenu
                            className={"form-control " + this.inputSelectTipoDataErrorClass()}
                            id="selectedTipoData"
                            name="selectedTipoData"
                            list={tipoDataList}
                            value={this.state.selectedTipoData}
                            onChange={this.handleTipoDataChange}
                            disabled={!this.state.habilitaBusca}
                        />
                        <div className="invalid-feedback">Informe qual data deseja utilizar no filtro</div>
                    </div>

                    <DateIntervalCalendar
                        htmlFor="SelectDatePeriod"
                        label="Escolher período"
                        handleFilterChange={this.handleDateFilterChange}
                        handleDateChange={this.handleDateChange}
                        missingFilterType={this.state.missingFilterType}
                        missingAnyDate={this.state.missingAnyDate}
                        disabled={!this.state.habilitaBusca}
                    />

                </div>

                <br />

                </div>
            )
        }

        const renderButtons = () => {
            if(this.state.habilitaBusca){
                return (
                    <Button
                        label="Buscar Boletos"
                        icon="pi pi-search"
                        onClick={this.callSearch}
                        disabled={this.state.isSearching}
                    />
                )
            }

            return (
                <Button
                    label="Voltar"
                    icon="pi pi-undo"
                    className="p-button-danger"
                    onClick={this.toggleButton}
                />
            )
        }

        const renderImportButton = () => {
            if(AuthService.getPerfil().isAdmin)
            return (
                <Button
                    label="Importar Boletos"
                    icon="pi pi-cloud-download"
                    className="p-button-secondary"
                    onClick={this.openImportDialog}
                />
            )
        }

        const renderImportDialogFooter = () => {
            return (
                <div>
                    <Button
                        label="Importar"
                        icon="pi pi-check"
                        onClick={this.callImportar}
                        disabled={this.state.isImporting}
                        loading={this.state.isImporting}
                    />
                    <Button
                        label="Cancelar"
                        icon="pi pi-times"
                        className="p-button-text"
                        onClick={this.closeImportDialog}
                        disabled={this.state.isImporting}
                    />
                </div>
            )
        }

        const renderImportDialog = () => {
            return (
                <Dialog
                    header="Importar Boletos do DDA"
                    visible={this.state.displayImportDialog}
                    modal={true}
                    style={{ width: '900px' }}
                    footer={renderImportDialogFooter()}
                    onHide={this.closeImportDialog}
                    closable={!this.state.isImporting}
                >
                    <p>Selecione o período de boletos que deseja importar.</p>
                    <p>O período de datas se refere à data de disponibilizados no DDA, e não de vencimento.</p>
                    <p>Eles serão importados diretamente das instituições bancárias.</p>

                    <div className="row dda-import-dialog-row">
                        <DateIntervalCalendar
                            htmlFor="SelectImportDatePeriod"
                            label="Escolher período"
                            handleFilterChange={this.handleImportDateFilterChange}
                            handleDateChange={this.handleImportDateChange}
                            missingFilterType={this.state.importMissingFilterType}
                            missingAnyDate={this.state.importMissingAnyDate}
                            disabled={this.state.isImporting}
                        />
                    </div>
                </Dialog>
            )
        }

        const renderTable = () => {
            if((this.state.isFinishedSearch && !this.state.habilitaBusca) || this.state.loading)
            return (
                <>
                    <br />
                    <br />
                    
                    <DDABoletoPagamentoTable
                        list={this.state.list}
                        loading={this.state.loading}
                    />
                </>
            )
        }

        return (
            <div className="bs-docs-section">
            <Card
                title="DDA - Boletos de Pagamento"
                rightComponent={renderImportButton()}
            >
                <div className="col-md-12">

                    {renderForm()}

                    {renderButtons()}

                    {renderTable()}

                </div>
            </Card>

            {renderImportDialog()}

            <div className="d-flex" />

            </div>
        )
    }

}

DDABoletoPagamento.contextType = AuthContext

export default withRouter(DDABoletoPagamento)
